import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WebsocketsState } from './websockets.model';
import { ModuleTokens } from './websockets.constant';

export const slice = createFeatureSelector<WebsocketsState>(ModuleTokens.Name);

export const reconnecting = createSelector(
  slice,
  (s) => s.reconnecting
);
